export const TeachingBubbleCategory = 'TeachingBubble';
export const FreCategory = 'FRE';
